import React, { Suspense } from "react";
import Loader from "../components/Loader";

const withSuspense = (LazyComponent) => {
  const WrappedComponent = (props) => (
    <Suspense fallback={<Loader pastDelay timedOut />}>
      <LazyComponent {...props} />
    </Suspense>
  );

  return WrappedComponent;
};

export default withSuspense;
